// Each choice is kept per user (keyed by Supabase user id) so each person
// decides once on their own account, even on a shared browser.
const DISMISSED_KEY_PREFIX = 'getting_started_dismissed_at:'
const WELCOMED_KEY_PREFIX = 'getting_started_welcomed_at:'
const DONE_STEPS_KEY_PREFIX = 'getting_started_done_steps:'

function userKey(prefix: string, userId: string | null): string {
  return `${prefix}${userId ?? 'anon'}`
}

function loadUserValue(prefix: string, userId: string | null) {
  if (typeof window === 'undefined') return null
  try {
    return window.localStorage.getItem(userKey(prefix, userId))
  } catch {
    return null
  }
}

function persistUserValue(
  prefix: string,
  userId: string | null,
  value: string,
) {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(userKey(prefix, userId), value)
  } catch {
    // Private mode or disabled storage: the choice is asked again next visit.
  }
}

export const loadDismissedAt = (userId: string | null): string | null =>
  loadUserValue(DISMISSED_KEY_PREFIX, userId)

export const persistDismissedAt = (userId: string | null, at: string) =>
  persistUserValue(DISMISSED_KEY_PREFIX, userId, at)

export const loadWelcomedAt = (userId: string | null): string | null =>
  loadUserValue(WELCOMED_KEY_PREFIX, userId)

export const persistWelcomedAt = (userId: string | null, at: string) =>
  persistUserValue(WELCOMED_KEY_PREFIX, userId, at)

export const loadDoneSteps = (userId: string | null): string[] => {
  const stored = loadUserValue(DONE_STEPS_KEY_PREFIX, userId)
  if (stored === null) return []
  try {
    const parsed: unknown = JSON.parse(stored)
    return Array.isArray(parsed)
      ? parsed.filter((key): key is string => typeof key === 'string')
      : []
  } catch {
    return []
  }
}

export const persistDoneSteps = (userId: string | null, stepKeys: string[]) =>
  persistUserValue(DONE_STEPS_KEY_PREFIX, userId, JSON.stringify(stepKeys))
